import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import KeyBenefits from '@/components/why-medihub/KeyBenefits';
import NotificationFeatures from '@/components/why-medihub/NotificationFeatures';
import RegistrationForm from '@/components/why-medihub/RegistrationForm';
import HeroSection from '@/components/why-medihub/HeroSection';
const WhyMediHub = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <HeroSection />
      <KeyBenefits />
      <NotificationFeatures />
      <RegistrationForm />
      <Footer />
    </div>
  );
};

export default WhyMediHub;

